<app-resumen-sucursales></app-resumen-sucursales>
<app-medicamentos-reponer></app-medicamentos-reponer>

